import { useEffect, useState } from "react";
import { Card, Row, Col, Typography, Button, Space, Flex } from "antd";
import { ArrowRightOutlined, SettingOutlined } from "@ant-design/icons";
import RecentActivityTable from "../../components/RecentActivityTable";
import { sellBoostFetch } from "../../utlifyFunction";
import AIUsage from "../../components/AIUsage";
import { Link } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import StoreOverview from "../../components/StoreOverview";
import ProductHistoryModal from "../../components/Modals/ProductHistoryModal";
import WelcomeCard from "../../components/Cards/WelcomeCard";
import { toast } from "react-toastify";
import OnboardingChecklist from "../../components/Cards/OnboardingChecklist.js";
import OnboardingTour from "../../components/onboarding/OnboardingTour.js";
import FeedbackBanner from "../../components/Banner/FeedbackBanner.js";

const { Title, Paragraph } = Typography;

const Dashboard = () => {
	const [loading, setLoading] = useState(false);
	const [history, setHistory] = useState(null);
	const [AIDescriptionUsed, setAIDescriptionUsed] = useState(null);
	const [storeOverview, setStoreOverview] = useState(null);
	const { userData } = useAuth();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [productToShowHistory, setProductToShowHistory] = useState(null);
	const [restoreButtonLoading, setRestoreButtonLoading] = useState(null);
	const [runTour, setRunTour] = useState(true);

	const fetchHistory = async () => {
		setHistory(null);
		const data = await sellBoostFetch("POST", "/user/getAiHistory", {
			limit: 5,
		});
		if (data?.history) {
			setHistory(data?.history);
			let count = data.history.reduce((acc, item) => acc + item.updateCount, 0);
			setAIDescriptionUsed(count);
		}
	};

	const getStoreOverview = async () => {
		const data = await sellBoostFetch("GET", "/user/getStoreOverview");
		if (data?.overview) {
			setStoreOverview(data.overview);
		}
	};

	const restoreDescription = async (
		productId,
		newDescription,
		oldDescription
	) => {
		setRestoreButtonLoading(true);
		const response = await sellBoostFetch("POST", "/shopify/updateProduct", {
			productId: productId,
			description: newDescription,
			oldDescription: oldDescription,
		});
		if (response?.status === 200) {
			toast.success("Product description updated!");
			setIsModalOpen(false);
			fetchHistory();
		}
		setRestoreButtonLoading(false);
	};
	useEffect(() => {
		fetchHistory();
		getStoreOverview();
	}, []);

	return (
		<div
			
		>
			{/* <OnboardingTour runTour={runTour} setRunTour={setRunTour} /> */}
			{/* Welcome Section */}
			<Flex vertical gap={"24px"}>
				<FeedbackBanner AIDescriptionUsed={AIDescriptionUsed} />

				{/* <OnboardingChecklist /> */}
				<WelcomeCard userData={userData} seoFixCount={0} />
			</Flex>

			{/* Dashboard Stats */}
			<Row gutter={[16, 16]} style={{ marginTop: 20,marginBottom:'20px', alignSelf: "stretch" }}>
				<Col xs={24} md={12} lg={8} id="ai-usage">
					<AIUsage AIDescriptionUsed={AIDescriptionUsed} />
				</Col>

				<Col xs={24} md={12} lg={8} id="store-overview">
					<StoreOverview storeOverview={storeOverview} />
				</Col>

				{/* Quick Actions */}
				<Col xs={24} md={12} lg={8}>
					<Card
						style={{
							borderRadius: "12px",

							height: "100%",
						}}
						id="quick-actions"
					>
						<Title level={4} style={{ marginBottom: 12 }}>
							⚙️ Quick Actions
						</Title>
						<Space direction="vertical" style={{ width: "100%" }}>
							<Link to={"/settings?tab=billing"}>
								<Button
									type="default"
									block
									style={{
										borderRadius: "8px",
										border: "1px solid #6D5BBA",
										color: "#6D5BBA",
										fontWeight: 500,
									}}
								>
									Go to Billing
								</Button>
							</Link>

							<Link to={"/settings"}>
								<Button
									type="dashed"
									block
									icon={<SettingOutlined />}
									style={{
										borderRadius: "8px",
										border: "1px dashed #6D5BBA",
										color: "#6D5BBA",
										fontWeight: 500,
									}}
								>
									Settings
								</Button>
							</Link>
						</Space>
					</Card>
				</Col>
			</Row>

			<RecentActivityTable
				recentActivity={history}
				setProductToShowHistory={setProductToShowHistory}
				setIsModalOpen={setIsModalOpen}
			/>
			<ProductHistoryModal
				visible={isModalOpen}
				onClose={() => setIsModalOpen(false)}
				product={productToShowHistory}
				restoreDescription={restoreDescription}
				restoreButtonLoading={restoreButtonLoading}
			/>
		</div>
	);
};

export default Dashboard;
